import React from 'react';
import {ClassRoomAPI} from "api";

/**
 * RIAPRIRE UNA CLASSE CHIUSA PER SBAGLIO — COMPLETED -> ACTIVE.
 *
 * IL FATTO (09/09/2026): una classe di due lezioni chiusa in modo PRECOCE dal docente, su un
 * modulo NON finale, quindi senza voti e senza attestati. E nessun modo di tornare indietro:
 * ATTIVA CLASSE non parte da COMPLETED, RIPRISTINA BOZZA nemmeno.
 *
 * ┌─ 🔴 NON E' «RIPRISTINA BOZZA», E NON GLI SI SOMIGLIA ────────────────────────────────┐
 * │ Quello porta in BOZZA e il server lo rifiuta appena un gruppo ha una vendita — cosa   │
 * │ che una classe conclusa ha SEMPRE. Questo riporta la classe fra le ATTIVE, dov'era.   │
 * │ Per questo il pulsante e' `btn-warning` e non `btn-danger`: non distrugge, DISFA.     │
 * └──────────────────────────────────────────────────────────────────────────────────────┘
 *
 * ┌─ ⚠️ LA DOMANDA DICE LE TRE COSE CHE CAMBIANO DAVVERO ────────────────────────────────┐
 * │ La classe torna attiva; gli esiti scritti dalla chiusura (promosso / non promosso)    │
 * │ vengono cancellati, e chi aveva abbandonato resta abbandonato; la data di fine si     │
 * │ svuota, perche' quella di prima l'ha sovrascritta la chiusura e non esiste piu' da    │
 * │ nessuna parte. La domanda viene PRIMA della scrittura: dopo e' tardi per saperlo.     │
 * └──────────────────────────────────────────────────────────────────────────────────────┘
 *
 * 🔴 `REOPEN_NOT_ALLOWED` E' UN NO DEFINITIVO e non si dice «riprova»: quella classe ha dei
 * voti, quindi puo' aver gia' prodotto degli attestati, e un attestato in mano a un corsista
 * non si disfa. La frase non AFFERMA che siano stati spediti — il server rifiuta anche quando i
 * voti sono arrivati da una correzione d'attestato di un'altra classe dello stesso livello — e
 * dice quello che si e' visto, non una diagnosi che non abbiamo.
 *
 * ⚠️ SOLO ADMIN, e la rotta dice lo stesso. Il pulsante che CHIUDE e' in mano al DOCENTE: se
 * chi chiude potesse anche riaprire, una classe conclusa mesi fa tornerebbe in piedi senza che
 * nessuno lo sappia. Chi sbaglia chiama la segreteria — l'attrito e' voluto.
 */
class ReopenClassroom extends React.Component {
    constructor(props) {
        super(props);
    }

    reopenClassroom() {
        const self = this;
        global.SweetAlert.fire({
            title: "Riapri la classe",
            text: 'La classe torna ATTIVA: il docente ci rientra e può riprendere le lezioni. Gli esiti scritti dalla chiusura (promosso / non promosso) vengono cancellati — chi aveva abbandonato resta abbandonato. E la data di fine si svuota: quella di prima è stata sovrascritta dalla chiusura e va rimessa a mano.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, riapri',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    ClassRoomAPI.reopen(self.props.classroom.id).then(() => {
                        resolve();
                    }).catch((err) => {
                        /* Tre rifiuti, tre frasi: chi sta davanti allo schermo fa tre gesti diversi.
                           Il generico e' l'ultimo, non il primo. */
                        let testo;
                        if (err && err.status === "REOPEN_NOT_ALLOWED")
                            testo = 'Questa classe ha dei voti registrati, quindi può aver già prodotto degli attestati: da qui non si riapre. Se è stata chiusa per sbaglio, va sistemata a mano.';
                        else if (err && err.status === "CLASSROOM_ALREADY_REOPENED")
                            testo = 'La classe è già stata riaperta un attimo fa. Ricarica la pagina.';
                        else if (err && err.status === "CLASSROOM_NOT_FOUND")
                            /* Il nome dell'errore mente: la classe esiste benissimo, ma non e' piu'
                               COMPLETED. Dire «classe non trovata» a chi ce l'ha davanti aperta non
                               aiuta nessuno; la sola cosa utile e' ricaricare. */
                            testo = 'Questa classe non risulta più conclusa: probabilmente l\'ha appena riaperta qualcun altro. Ricarica la pagina per vedere com\'è adesso.';
                        else
                            testo = 'Purtroppo qualcosa è andato storto e non è stato possibile riaprire la classe. Riprova più tardi.';

                        global.SweetAlert.fire({
                            icon: 'error',
                            title: 'Si è verificato un errore :(',
                            text: testo,
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject()
                    })
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Classe riaperta!',
                    text: 'La classe è tornata attiva. La data di fine è vuota: rimettila dal dettaglio della classe.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                self.props.onResolve();
            }
        })
    }


    render() {
        return (
            <React.Fragment>
                <button
                    type="button"
                    className="btn btn-warning btn-sm"
                    onClick={() => this.reopenClassroom()}>
                    <i className="ri-arrow-go-back-fill align-bottom me-1"></i> RIAPRI LA CLASSE
                </button>
            </React.Fragment>
        )
    }
}

export default ReopenClassroom;
